import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "scroll-img"
}
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "img-content"
}
const _hoisted_4 = ["src", "onClick"]

import {onMounted, ref, nextTick, onUnmounted} from "vue";
import {showImagePreview} from 'vant';
interface Props{
  list:any
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollImg',
  props: {
    list: { default: [] }
  },
  setup(__props: any) {

let _setInterval:any=null,pos=0;
const props=__props
const move = ref('');
const showRepeat=ref(false);
let width:any=0;
const showImg=ref(false);
// onMounted(()=>{
//
// })
onUnmounted(()=>{
  clearInterval(_setInterval);
  _setInterval=null;
})

const imgLoad=()=>{
  getMove();
}
const getMove=()=>{
  const imgWidth=document.getElementById('imglist')?.offsetWidth||0;

  nextTick(()=>{
    console.log('imgWidth',imgWidth,document.body.offsetWidth)
    if(imgWidth>document.body.offsetWidth) {
      showRepeat.value=true;
      width=imgWidth
      startmove();
    }
  })
}
const startmove=()=>{
  if(!_setInterval)
    _setInterval=setInterval(()=>{
      pos=pos+0.5
      move.value=-pos+'px';
      if(pos>=width){
        pos=0;
      }
    },10)

}
const choose=(pos:number)=>{
  clearInterval(_setInterval);
  _setInterval=null;

  let images=[];
  for(let i=0;i<props.list.length;i++){
    images.push(props.list[i].obituaryimg)
  }
  showImg.value=true;
  showImagePreview({
    images: images,
    startPosition: pos,
    onClose() {
      showImg.value=false;
      startmove();
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_ctx.list.length===0)
    ? (_openBlock(), _createBlock(_component_van_empty, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "img-content",
          style: _normalizeStyle({'margin-left':move.value}),
          id: "imglist"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("img", {
              class: "image",
              src: item.obituaryimg,
              onLoad: imgLoad,
              onClick: ($event: any) => (choose(index)),
              key: item.id
            }, null, 40, _hoisted_2))
          }), 128))
        ], 4),
        (showRepeat.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  class: "image",
                  src: item.obituaryimg,
                  onLoad: imgLoad,
                  onClick: ($event: any) => (choose(index)),
                  key: item.id
                }, null, 40, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})